module.exports = __webpack_public_path__ + "static/media/speechActive.59edcc34.svg";